export const zaragozaDataSources = [
  {
    title: 'Zaragoza Engineering',
    content: `The Zaragoza Akira tile draws upon two factory-specific SharePoint document libraries — the **Business Process Design Documents** and the **Continuous Improvement Design Manuals** — which together constitute the site's primary repository of technical and engineering process knowledge. The objective is to enable Zaragoza PGTR engineers to retrieve relevant documentation through natural language queries via the Akira platform, eliminating the need for manual navigation across disparate SharePoint libraries.`,
    sourceSystem: null,
    prompts: [
        'What are the minimum and maximum resin thicknesses for a wiredrop coil?',
        'What combination of end-fill insulation thicknesses is required for a 2 mm thick foil?',
        'What is the inner mold drawing for a 300 mm diameter foil winding coil?',
        'What is the SAP code for a 125 mm C5H wheel?',
        'Should no-load losses be indicated on the rating plate in accordance with IEC 60076-11?'
    ],
    datasourcelink:''
  }
]